<template>
  <div>
    <iframe src="http://wechat.lechun.cc/link_lcasdf" frameborder="0" scrolling="auto" style="width: 100%;height: 1500px;"></iframe>

  </div>
</template>

<script>
export default {
name: "miniLink"
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/shortlink/miniLink.vue